import Booked16 from '@sats-group/icons/16/booked';
import Forward24 from '@sats-group/icons/24/forward';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import type { MembershipCard as Props } from './membership-card.types';

const MembershipCard: React.FunctionComponent<Props> = ({
  href,
  name,
  onClick,
  price,
  tag,
  usps,
}) => (
  <a className="membership-card" href={href} onClick={onClick}>
    <div className="membership-card__information">
      <div className="membership-card__header">
        <Text
          className="membership-card__name"
          elementName="span"
          size={Text.sizes.header1}
          variant={Text.variants.contrast}
        >
          {name}
        </Text>
        {tag ? (
          <Text
            className="membership-card__tag"
            elementName="span"
            size={Text.sizes.small}
          >
            {tag}
          </Text>
        ) : null}
      </div>
      <ul className="membership-card__usps">
        {usps.map(usp => (
          <li className="membership-card__usp" key={usp}>
            <span aria-hidden className="membership-card__check">
              <Booked16 />
            </span>
            <Text elementName="span" size={Text.sizes.small}>
              {usp}
            </Text>
          </li>
        ))}
      </ul>
    </div>
    <div className="membership-card__price-and-action">
      <div className="membership-card__price">
        <div className="membership-card__price-main">
          <Text
            className="membership-card__price-value"
            elementName="span"
            size={Text.sizes.header1}
            variant={Text.variants.hero}
          >
            {price.value}
          </Text>
          <Text elementName="span">{price.unit}</Text>
        </div>
        {price.disclaimers &&
          price.disclaimers.map(disclaimer => (
            <Text elementName="span" key={disclaimer} size={Text.sizes.small}>
              {disclaimer}
            </Text>
          ))}
      </div>
      <span aria-hidden className="membership-card__forward">
        <Forward24 />
      </span>
    </div>
  </a>
);

export default MembershipCard;
